import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { Router } from '@angular/router';
import { Lightbox } from 'ngx-lightbox';
import DateHelper from '../../../../helpers/date-helper';
import { ClientPendingSubProject } from '../../../../model/project/client-pending-sub-project';
import { SubProjectControllerRequestService } from '../../../../services/api/sub-project-controller-request.service';
import { ClientCompanySelectService } from '../../../../services/client-company-select.service';
import { FilterStoreService } from '../../../../services/filter-store.service';
import { PageIndexService } from '../../../../services/page-index-service';
import { AbstractImmoOverviewComponent } from '../abstract-immo-overview.component';
import { STATUS } from '../../../../model/project/status';

//Putting this here because it inherits the abstract immo page, even if a part of client corner...
//Component and page structure could use some improvement

@Component({
  selector: 'client-corner-pending-overview',
  templateUrl: '../abstract-immo-overview.component.html',
  styleUrls: ['./client-corner-pending-overview.component.scss'],
})
export class ClientCornerPendingOverviewComponent extends AbstractImmoOverviewComponent<ClientPendingSubProject> {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    protected filterStoreService: FilterStoreService,
    protected pageIndexService: PageIndexService,
    protected cd: ChangeDetectorRef,
    protected subProjectService: SubProjectControllerRequestService,
    protected _lightbox: Lightbox,
    protected router: Router,
    private clientCompanySelectService: ClientCompanySelectService
  ) {
    super(
      [
        {
          key: 'project__id',
          active: false,
          strictEquality: true,
          numeric: true,
        },
        {
          key: 'currentCreatedAt',
          active: false,
          strictEquality: true,
          numeric: false,
        },
        {
          key: 'projectPlacement__address',
          active: false,
          strictEquality: true,
          numeric: false,
        },
      ],
      filterStoreService,
      pageIndexService,
      cd,
      subProjectService,
      _lightbox,
      router,
      true
    );
  }

  public openTour(subProject: ClientPendingSubProject): void {
    throw new Error('Method not implemented.');
  }
  public copyProjectId(subProject: ClientPendingSubProject): void {
    throw new Error('Method not implemented.');
  }
  protected getPaginator(): MatPaginator {
    return this.paginator;
  }

  // Override
  protected initializePageSize(localStoredPageSize: number): void {
    this.getPaginator().pageSize =
      localStoredPageSize != null ? localStoredPageSize : 30;
  }

  protected initDisplayedColumns(): void {
    this.displayedColumns = [
      'projectId',
      'request',
      'desiredDateClient',
      'placementDateClient',
      'requestor',
      'delayedReasonShort',
      'appointment',
      'followUp',
      'address',
      'kind',
      'measurements',
      'type',
      'photo',
      'design',
      'displayStatusDelayed',
    ];
  }
  protected initSortSettings(): void {
    this.sortColumn = 'currentConfirmedPlacementDate';
    this.sortAscending = true;
  }
  protected fetchItems(): void {
    this.loading = true;
    this.items = [];

    this.subProjectService
      .getClientPending(
        this.clientCompanySelectService.getSelectedCompanyId(),
        this.generateFilterString(),
        this.sortColumn,
        this.sortAscending,
        this.paginator.pageSize,
        this.paginator.pageIndex,
        false
      )
      .then((res) => {
        this.processPageResult(res);
        this.totalItems = res.totalItems;
        //No count change here
        this.items = this.parseFetchedItems(res.items);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private parseFetchedItems(
    items: ClientPendingSubProject[]
  ): ClientPendingSubProject[] {
    items.forEach((e) => {
      e.currentRequestDateDisplay = DateHelper.formatDate(e.currentRequestDate);
      e.currentCreatedAtDisplay = DateHelper.formatDate(e.currentCreatedAt);
      e.currentConfirmedPlacementDateDisplay = DateHelper.formatDate(
        e.currentConfirmedPlacementDate
      );
      if (
        e.project != null &&
        e.project.products != null &&
        e.project.products.length > 0
      ) {
        e.project.firstIpBoard = e.project.products[0];
      }
    });

    return items;
  }

  public openProject(subProject: ClientPendingSubProject) {
    if (subProject.status === STATUS.DRAFT.valueOf()) {
      this.router.navigate(['client-project/nieuw', subProject.project.id]);
    } else {
      this.router.navigate([
        'klant-opdracht',
        subProject.project.id,
        subProject.id,
      ]);
    }
  }
  protected getLocalStorageKey(): string {
    return 'ClientCornerPendingOverviewComponent';
  }
}
